module.exports = __webpack_public_path__ + "img/email.3468a29e.png";